export default {
  props: {
    landscape: Boolean,
    noDisplay: Boolean,
    displayColor: String
  }
};



// WEBPACK FOOTER //
// ./src/muse-ui/Picker/mixins/props.js